import { Switch } from "@headlessui/react";
import { PencilIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "react-tooltip";
import TooltipWrapper from "./TooltipWrapper";

interface StylingToggleProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  hidden?: boolean;
  tooltipContent?: string;
}

export function StylingToggle({
  label,
  checked,
  onChange,
  hidden,
  tooltipContent,
}: StylingToggleProps) {
  if (hidden) {
    return null;
  }
  return (
    <div
      className={`flex flex-row items-center gap-x-4 justify-start relative`}
    >
      {label}
      {tooltipContent && (
        <div className="absolute -left-8">
          <TooltipWrapper
            id={`unique-section-tooltip-${label}`}
            content={tooltipContent}
          >
            <div className="text-sm bg-gray-100 p-1 rounded-md px-1">
              <PencilIcon className="h-4 w-4" />
            </div>
          </TooltipWrapper>
        </div>
      )}
      <Switch
        checked={checked}
        onChange={onChange}
        className={`${checked ? "bg-green-600" : "bg-red-600"}
                relative inline-flex h-[25px] w-[50px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${checked ? "translate-x-6" : "translate-x-0"}
                    pointer-events-none inline-block h-[20px] w-[20px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
}
